import { render, staticRenderFns } from "./AttendanceFeedbackPopup.vue?vue&type=template&id=585ef1f0&scoped=true"
import script from "./AttendanceFeedbackPopup.vue?vue&type=script&lang=js"
export * from "./AttendanceFeedbackPopup.vue?vue&type=script&lang=js"
import style0 from "./AttendanceFeedbackPopup.vue?vue&type=style&index=0&id=585ef1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ef1f0",
  null
  
)

export default component.exports